var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHkg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1474_26593)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2387 9.07837C12.966 10.2127 12.4815 9.99637 12.2437 10.9856C10.8429 10.6488 9.98021 9.24023 10.317 7.83937C10.6537 6.43861 12.0624 5.57592 13.4632 5.91271C12.9876 7.89117 13.4827 8.06386 13.2387 9.07837Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.60395 9.9192C10.5985 10.529 10.243 10.9231 11.1103 11.455C10.3571 12.6832 8.75092 13.0683 7.5227 12.3151C6.29453 11.562 5.90936 9.95571 6.66255 8.72754C8.3972 9.79123 8.71431 9.37371 9.60395 9.9192V9.9192Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.28044 13.6358C10.1678 12.8784 10.4326 13.3382 11.2065 12.6777C12.1419 13.7735 12.0117 15.4202 10.916 16.3555C9.82016 17.2909 8.17353 17.1607 7.23828 16.065C8.78581 14.7439 8.4867 14.3132 9.28044 13.6358Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7145 15.0924C12.2683 14.0144 12.7875 13.9046 12.3984 12.9646C13.7296 12.4136 15.2555 13.0462 15.8065 14.3774C16.3574 15.7086 15.7248 17.2344 14.3936 17.7854C13.6156 15.9053 13.1136 16.0566 12.7145 15.0924Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1608 12.2753C13.9977 12.3665 14.0535 11.8387 13.0394 11.9183C12.9267 10.4821 13.9999 9.22629 15.4362 9.11356C16.8724 9.00111 18.1282 10.0742 18.2408 11.5105C16.2122 11.6696 16.201 12.1938 15.1608 12.2753Z",
  fill: "#F0F0F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1474_26593"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHkg);
export { ForwardRef as ReactComponent };